import { create } from 'zustand';

interface CaptureStore {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export const useCaptureStore = create<CaptureStore>((set) => ({
  isModalOpen: false,
  openModal: () => set({ isModalOpen: true }),
  closeModal: () => set({ isModalOpen: false }),
}));
